class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.variantOptionsRequestId = 0;
    this.variantOptionsAbortController = null;
    this.rerenderRequestId = 0;
    this.rerenderAbortController = null;
  }
  connectedCallback() {
    let that = this;
    if(document.readyState == 'loading')
      document.addEventListener('DOMContentLoaded', () => {that.init();});
    else
      that.init();
  }
  init() {
    let that = this;
    that.section = that.closest('.js-product');
    that.productForm = that.section.querySelector('.js-product-form');
    const dataEl = that.querySelector('script#variant-selector-data[type="application/json"]');
    that.data = JSON.parse(dataEl.textContent);
    const variantIdInput = that.productForm.querySelector('input[name="id"]');
    that.currentVariant = that.data.product.variants.find((variant) => variant.id == variantIdInput.value);
    that.setEventListeners();
  }
  setEventListeners() {
    let that = this;
    const valueInputs = that.querySelectorAll('input.value-input');
    valueInputs.forEach((valueInput) => {
      valueInput.addEventListener('input', () => {
        const optionIndex = Number(valueInput.getAttribute('name').replace('option', ''))-1;
        const optionName = that.data.product.options[optionIndex]?.toLowerCase();
        const product_url = valueInput.dataset.productUrl;
        let isColor = false;
        if(optionName == 'barva' || optionName == 'color' || optionName == 'colour' || optionName == 'boja' || optionName == 'farbe'){
          isColor = true;
        }
        that.selectVariant(product_url, valueInput.value, isColor);
      });
    });
  }
  selectVariant(product_url, variantId, isColor) {
    let that = this;
    let sectionId = that.dataset.sectionId;
    if(!!product_url && product_url != ''){
      const option_values = Array.from(that.querySelectorAll('.option input.value-input:checked')).map((element) => element.dataset.valueId);
      that.rerenderSection(sectionId, product_url, option_values);
    } else {
      const newUrl = new URL(location);
      newUrl.searchParams.delete('option_values');
      history.replaceState(null, "", newUrl.href);
      that.currentVariant = that.data.product.variants.find((variant) => variant.id == variantId);
      that.updateVariantSelector();
      that.updateVariantInput();
      that.updateButtons();
      that.updateVariantTitle();
      that.updateDeeplinking();
      that.updateAddToCartButton();
      that.updatePrice();
      that.updateBackorderText();
      that.updatePickupAvailability();
      that.updateSku();
      if(isColor){
        that.updateImages();
      }
      that.dispatchEvent(
        new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: that.productForm,
            variant: that.currentVariant,
            product: that.data.product,
          },
        })
      );
    }
  }
  rerenderSection(sectionId, product_url, option_values) {
    const that = this;
    const section = document.querySelector(`#shopify-section-${sectionId}`);
    const newUrl = new URL(location);
    newUrl.searchParams.delete('variant');
    if(newUrl.pathname.includes('/collections/')){
      const collectionPrefix =  newUrl.pathname.split('/products/').shift();
      const productHandle = product_url.split('/products/').pop();
      console.log(collectionPrefix, productHandle);
      newUrl.pathname = [collectionPrefix, productHandle].join('/products/');
    } else {
      newUrl.pathname = product_url;
    }
    if(option_values.length > 0){
      newUrl.searchParams.set('option_values', option_values.shift());
    } else {
      newUrl.searchParams.delete('option_values');
    }
    history.replaceState(null, "", newUrl.href);
    newUrl.pathname = product_url;
    newUrl.searchParams.set('section_id', sectionId);

    that.rerenderRequestId += 1;
    const requestId = that.rerenderRequestId;
    if (that.rerenderAbortController) {
      that.rerenderAbortController.abort();
    }
    that.rerenderAbortController = new AbortController();
    
    fetch(newUrl.href, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET',
      signal: that.rerenderAbortController.signal
    })
    .then(response => response.text())
    .then(data => {
        if (requestId !== that.rerenderRequestId) {
          return;
        }
        let template = document.createElement('template');
        template.innerHTML = data.trim();
        let firstChild = template.content.firstChild;
        const new_options = firstChild.querySelectorAll('variant-selector .option');
        const old_options = section.querySelectorAll('variant-selector .option');
        const new_product_info = firstChild.querySelector('.product-info');
        const old_product_info = section.querySelector('.product-info');
        const new_product_media = firstChild.querySelector('.product-media');
        const old_product_media = section.querySelector('.product-media');
        const new_variant_data = firstChild.querySelector('#variant-selector-data');
        const old_variant_data = section.querySelector('#variant-selector-data');
        old_options.forEach((option, index) => {
          const new_option = new_options[index];
          if(!!new_option) {
            option.innerHTML = new_option.innerHTML;
          }
        });
        if(!!new_product_info && !!old_product_info) {
          old_product_info.innerHTML = new_product_info.innerHTML;
        }
        if(!!new_product_media && !!old_product_media) {
          old_product_media.innerHTML = new_product_media.innerHTML;
        }
        if(!!new_variant_data && !!old_variant_data) {
          old_variant_data.replaceWith(new_variant_data);
        }
        that.init();
        section.querySelector('product-and-variant-selector')?.init();
        window.initLazyImages();    
    })
    .catch(function(err) {
        if (err.name === 'AbortError') {
          return;
        }
        console.error(err);
    });
  }
  updateVariantSelector() {
    const that = this;
    if (that.currentVariant) {
      const url = new URL(location)
      url.searchParams.set('variant', that.currentVariant.id);
      url.searchParams.set('section_id', that.dataset.sectionId);

      that.variantOptionsRequestId += 1;
      const requestId = that.variantOptionsRequestId;
      if (that.variantOptionsAbortController) {
        that.variantOptionsAbortController.abort();
      }
      that.variantOptionsAbortController = new AbortController();

      fetch(url, { signal: that.variantOptionsAbortController.signal }).then(response => response.text()).then(data => {
        if (requestId !== that.variantOptionsRequestId) {
          return;
        }
        let template = document.createElement('template');
        template.innerHTML = data.trim();
        let firstChild = template.content.firstChild;
        const variantSelector = firstChild.querySelectorAll('variant-selector .option-content')
        document.querySelectorAll('variant-selector .option-content').forEach((optionContainer,index) => {
          if (variantSelector[index]) {
            optionContainer.innerHTML = variantSelector[index].innerHTML.trim()
          }
        })
        that.setEventListeners();
      }).catch((err) => {
        if (err.name === 'AbortError') {
          return;
        }
        console.error(err);
      });

    }
  }
  updateVariantInput() {
    const that = this;
    const variantIdInput = that.productForm.querySelector('input[name="id"]');
    if (!!variantIdInput && that.currentVariant) {
      variantIdInput.value = that.currentVariant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  updateButtons(){
    let that = this;
    if (!that.currentVariant) return
    that.currentVariant.options.forEach((option, index) => {
      const optionId = 'option'+(index+1);
      const optionName = that.data.options[index].name;
      let formattedOption = option.split('|').find(split => (split.includes('men') || split.includes('moški') && !split.includes('women')));
      if(!!formattedOption){
        formattedOption = formattedOption.replace('men ', '').replace('moški ', '');
      }else{
        formattedOption = option.split('|').pop();
        formattedOption = formattedOption.split('/').join(' / ');
        formattedOption = formattedOption.split('+').join(' + ');
      }
      document.querySelectorAll(`#main-content [data-${optionId}-value]`).forEach(optionValueNode => {
        const colorTranslations = 'Color,Colour,Couleur,Farbe,Barva,Boja';
        if(colorTranslations.includes(optionName)){
          let colorName = that.data.formatted[that.currentVariant.id].colorSwatchName;
          if(!!colorName){
            colorName = colorName.split('/').join(' / ');
            optionValueNode.innerHTML = colorName;
          }
        }else{
          optionValueNode.innerHTML = formattedOption;
        }
      });
      document.querySelectorAll(`#main-content [data-open-option="${optionId}"] .swatch`).forEach(swatch => {
        const currentLabel = document.querySelector(`#main-content [data-option-id="${optionId}"] input:checked + label .swatch`);
        swatch.innerHTML = currentLabel.innerHTML;
      });
    });
  }
  updateVariantTitle() {
    const that = this;
    if (!that.currentVariant) return
    that.currentVariant.options.forEach((option, index) => {
      const optionId = 'option'+(index+1);
      const optionName = that.data.options[index].name;
      const currentVariantTitleNodes = that.section.querySelectorAll(`#main-content [data-option-id="${optionId}"] [data-variant-title]`);
      currentVariantTitleNodes.forEach(currentVariantTitleNode => {
        const colorTranslations = 'Color,Colour,Couleur,Farbe,Barva,Boja';
        if(colorTranslations.toLowerCase().includes(optionName.toLowerCase())){
          let colorName = that.data.formatted[that.currentVariant.id].colorSwatchName;
          if(!!colorName){
            colorName = colorName.split('/').join(' / ');
            currentVariantTitleNode.innerHTML = colorName;
          }
        }else{
          currentVariantTitleNode.innerHTML = option;
        }
      });
    });
  }
  updateDeeplinking() {
    const that = this;
    if (!that.currentVariant) return
    const params = new URL(document.location).searchParams;
    params.set('variant', that.currentVariant.id);
    const newUrl = new URL(document.location);
    newUrl.search = params.toString();
    const newHistoryState = newUrl.href.split('/').pop();
    window.history.replaceState(null, 'variant -> ' + that.currentVariant.id, newHistoryState);
  }
  updateAddToCartButton() {
    const that = this;
    if (!that.productForm) return;
    that.addBtn = that.addBtn || that.productForm.querySelector('[name="add"]');
    const variantAvailable = that.currentVariant && that.currentVariant.available;
    const unavailableStr = that.currentVariant ? theme.strings.noStock : theme.strings.noVariant;
    that.addBtn.disabled = !variantAvailable;
    that.addBtn.textContent = variantAvailable ? this.addBtn.dataset.addToCartText : unavailableStr;
  }
  updatePrice() {
    const that = this;
    that.price = that.section.querySelector('.product-info__price > .price');
    that.scalePrice = that.section.querySelector('.product-price .scalePrice');
    if (!that.price) return;
    if (that.currentVariant) {
      const priceCurrentEl = that.price.querySelector('.price__current[data-vat="with-vat"]');
      const priceWasEl = that.price.querySelector('.price__was[data-vat="with-vat"]');
      const unitPriceEl = that.price.querySelector('.unit-price');

      // Update current price and original price if on sale.
      priceCurrentEl.innerHTML = that.data.formatted[that.currentVariant.id].price;
      if (priceWasEl) priceWasEl.innerHTML = that.data.formatted[that.currentVariant.id].compareAtPrice || '';
  
      // Update unit price, if specified.
      if (that.currentVariant.id.unit_price_measurement) {
        const valueEl = that.price.querySelector('.unit-price__price');
        const unitEl = that.price.querySelector('.unit-price__unit');
        const value = that.currentVariant.unit_price_measurement.reference_value;
        const unit = that.currentVariant.unit_price_measurement.reference_unit;
        valueEl.innerHTML = that.data.formatted[that.currentVariant.id].unitPrice;
        unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
      }

      //scale price, if specified
      if (!!that.scalePrice) {
        var scalePriceData =  that.data.formatted[that.currentVariant.id].scalePrice || '';
        for (const [key, value] of Object.entries(scalePriceData)) {
          let quantity_value = key.split('_')[1]
          let scalePriceHTML = that.scalePrice.querySelector('[data-vat="with-vat"] [data-quantity="' + quantity_value + '"] .price')
          if (!!scalePriceHTML) {
            scalePriceHTML.innerHTML = value
          }
        }
      }
      unitPriceEl.hidden = !that.currentVariant.id.unit_price_measurement;
      that.price.classList.toggle('price--on-sale', that.currentVariant.compare_at_price > that.currentVariant.price);
      that.price.classList.toggle('price--sold-out', !that.currentVariant.available);
    }

    that.price.querySelector('.price__default').hidden = !that.currentVariant;
    that.price.querySelector('.price__no-variant').hidden = that.currentVariant;
  }
  updateBackorderText() {
    const that = this;
    that.backorder = that.section.querySelector('.backorder');
    if (!that.backorder) return;
    let hideBackorder = true;
    if (that.currentVariant && that.currentVariant.available) {
      const { inventory } = that.data.formatted[that.currentVariant.id];
      if (that.currentVariant.inventory_management && inventory === 'none') {
        const backorderProdEl = that.backorder.querySelector('.backorder__product');
        const prodTitleEl = that.section.querySelector('.product-title');
        const variantTitle = that.currentVariant.title.includes('Default') ? '' : ` - ${that.currentVariant.title}`;

        backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
        hideBackorder = false;
      }
    }
    this.backorder.hidden = hideBackorder;
  }
  updatePickupAvailability() {
    const that = this;
    that.pickUpAvailability = that.section.querySelector('pickup-availability');
    if (!that.pickUpAvailability) return;
    if (that.currentVariant && that.currentVariant.available) {
      that.pickUpAvailability.getAvailability(that.currentVariant.id);
    } else {
      that.pickUpAvailability.removeAttribute('available');
      that.pickUpAvailability.innerHTML = '';
    }
  }
  updateSku() {
    const that = this;
    that.sku = that.section.querySelector('.product-sku__value');
    if (!that.sku) return;
    const skuAvailable = that.currentVariant && that.currentVariant.sku;
    that.sku.textContent = skuAvailable ? '#' + that.currentVariant.sku : '';
    that.sku.parentNode.hidden = !skuAvailable;
  }
  updateImages() {
    const that = this;
    const sectionId = that.section.dataset.section;
    const params = new URL(document.location).searchParams;
    params.set('variant', that.currentVariant.id);
    params.set('sections', sectionId);
    const newUrl = new URL(document.location);
    newUrl.search = params.toString();
    fetch(newUrl.href, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    })
    .then(response => response.json())
    .then(data => {
      let template = document.createElement('template');
      template.innerHTML = data[sectionId].trim();
      const oldProductImages = document.querySelector('#product-media');
      const newProductImages = template.content.querySelector('#product-media');
      if(!!oldProductImages && newProductImages){
        oldProductImages.replaceWith(newProductImages);
      }
    })
    .catch(function(err) {
        console.error(err);
    });
  }
}
customElements.define('variant-selector', VariantSelector);

class ProductSelector extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    if(document.readyState == 'loading') 
      document.addEventListener('DOMContentLoaded', () => {that.init();});
    else
      that.init();
  }
  init() {
    let that = this;
    that.section = that.closest('.js-product');
    const dataEl = that.querySelector('script#product-selector-data[type="application/json"]');
    that.data = JSON.parse(dataEl.textContent);
    that.setEventListeners();
  }
  setEventListeners() {
    let that = this;
    const valueInputs = that.querySelectorAll('input.value-input');
    valueInputs.forEach((valueInput) => {
      valueInput.addEventListener('input', () => {
        that.selectProduct(valueInput.value);
      });
    });
  }
  selectProduct(productId) {
    let that = this;
    let currentVariant = null;
    let variantWithSameOptions = null;
    const variantSelector = that.section.querySelector('variant-selector');
    if(variantSelector) {
      currentVariant = variantSelector.currentVariant;
    }
    if(currentVariant){
      const productVariants = that.data.products[productId].variants;
      variantWithSameOptions = productVariants.find(variant => variant.option1 == currentVariant.option1 && variant.option2 == currentVariant.option2 && variant.option3 == currentVariant.option3);
      if(!variantWithSameOptions) {
        variantWithSameOptions = productVariants.find(variant => variant.option1 == currentVariant.option1 && variant.option2 == currentVariant.option2);
      }
      if(!variantWithSameOptions) {
        variantWithSameOptions = productVariants.find(variant => variant.option1 == currentVariant.option1);
      }
    }
    const sectionId = that.data.sectionId; 
    const productHandle = that.data.products[productId].handle;
    const variantId = !!variantWithSameOptions ? variantWithSameOptions.id : null;
    if(!!variantWithSameOptions){
      console.log('selectVariantProductSelector', variantWithSameOptions);
    }
    if(sectionId && productHandle) {
      that.rerenderSection(sectionId, productHandle, variantId); 
      // at this point the section is rendered and normally ready to use. 
    }
  }
  rerenderSection(sectionId, productHandle, variantId) {
    const that = this;
    const section = document.querySelector(`#shopify-section-${sectionId}`);
    const params = new URL(document.location).searchParams;
    if(variantId) {
      params.set('variant', variantId);
    } else {
      params.delete('variant');
    }
    const newUrl = new URL(document.location);
    newUrl.search = params.toString();
    const market = newUrl.pathname.split('/products/').length > 0 ? newUrl.pathname.split('/products/')[0] : '';
    newUrl.pathname = market+'/products/'+productHandle;
    window.history.replaceState(null, 'product -> ' + productHandle, newUrl.href);
    params.set('section_id', sectionId);
    newUrl.search = params.toString();
    
    fetch(newUrl.href, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    })
    .then(response => response.text())
    .then(data => {
        let template = document.createElement('template');
        template.innerHTML = data.trim();
        let firstChild = template.content.firstChild;
        let productAndVariantSelector = firstChild.querySelector('product-and-variant-selector');
        let productSelector = firstChild.querySelector('product-selector .option.option-sibling');
        if(!!productAndVariantSelector){
          productAndVariantSelector.classList.add('active');
        }
        if(!!productSelector){
          productSelector.classList.add('active');
        }
        section.replaceWith(firstChild);
        window.initLazyImages();    
    })
    .catch(function(err) {
        console.error(err);
    });
  }
}
customElements.define('product-selector', ProductSelector);

class ProductAndVariantSelector extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    if(document.readyState == 'loading')
      document.addEventListener('DOMContentLoaded', () => {that.init();});
    else
      that.init();
  }
  init() {
    let that = this;
    that.section = that.closest('.js-product');
    const options = that.querySelectorAll('.option');
    const openToggles = that.section.querySelectorAll('[data-open-option]');
    const closeToggles = that.section.querySelectorAll('[data-close-option]');
    const closeAllToggles = that.section.querySelectorAll('[data-close-all]');
    openToggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        var variantSelectOpen = new Event('variantSelect:open');
        document.dispatchEvent(variantSelectOpen);
        const openOption = that.querySelector('.option.'+toggle.dataset.openOption);
        if (openOption != null && openOption.classList.contains('active')) {
          options.forEach(option => {
            that.closeOption(option);
          });
          that.enableScroll(openOption);
        }
        else {
          options.forEach(option => {
            that.closeOption(option);
          });
          that.openOption(openOption);
          that.disableScroll();
        }
      });
    });
    closeToggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        const closeOption = that.querySelector('.option.'+toggle.dataset.closeOption);
        if(closeOption) {
          that.closeOption(closeOption);
        }
        that.enableScroll();
      });
    });
    closeAllToggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        options.forEach(option => {
          that.closeOption(option);
        });
        that.enableScroll();
      });
    });
  }
  getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }
  enableScroll() {
    let that = this;
    document.body.style.position = null;
    document.body.style.top = null;
    document.body.style.overflow = null;
    document.body.style.paddingRight = null;
    document.documentElement.scrollTop = document.body.scrollTop = that.scrollPos;
    document.documentElement.style.setProperty('--page-translate-x', '0px');
    that.classList.remove('active');
    document.querySelectorAll('clever-slider').forEach(slider => {
      if(!!slider.embla){
        slider.embla.reInit();
      }
    });
  }
  disableScroll() {
    let that = this;
    that.scrollPos = (document.documentElement.scrollTop || document.body.scrollTop)
    document.body.style.position = 'fixed';
    document.body.style.top = (that.scrollPos * -1)+'px';
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = that.getScrollbarWidth()+'px';
    document.documentElement.style.setProperty('--page-translate-x', '-375px');
    that.classList.add('active');
  }
  openOption(option) {
    let that = this;
    const optionID = option.dataset.optionId;
    const toggles = that.section.querySelectorAll('[data-open-option="'+optionID+'"]');
    toggles.forEach(toggle => {
      toggle.classList.add('active');
    });
    option.classList.add('active');
  }
  closeOption(option) {
    let that = this;
    const optionID = option.dataset.optionId;
    const toggles = that.section.querySelectorAll('[data-open-option="'+optionID+'"]');
    toggles.forEach(toggle => {
      toggle.classList.remove('active');
    });
    option.classList.remove('active');
  }
}
customElements.define('product-and-variant-selector', ProductAndVariantSelector);

function handleClickOutside(event){
  let that = document.querySelector('product-and-variant-selector');
  if(!!that){
    const active_options = that.querySelectorAll('.option.active');
    const toggle = event.target.hasAttribute('data-open-option') || event.target.closest('[data-open-option]');
    if(active_options.length > 0 && !that.contains(event.target) && !toggle){
      active_options.forEach(option => {
        that.closeOption(option);
      });
      that.enableScroll();
    }
  }
}
document.body.addEventListener('click', handleClickOutside);

class ProductOptionTabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    if(document.readyState == 'loading')
      document.addEventListener('DOMContentLoaded', () => {that.init();});
    else
      that.init();
  }
  hideAll(titles, contents) {
    titles.forEach(title => {
      title.classList.remove('active');
    });
    contents.forEach(content => {
      content.classList.add('hidden');
    });
  }
  init() {
    const that = this;
    const sizeTypeTitleShort = that.querySelector('.option-title-short');
    const sizeTypeTitleRegular = that.querySelector('.option-title-regular');
    const sizeTypeTitleLong = that.querySelector('.option-title-long');
    const sizeTypeTitleUndefined = that.querySelector('.option-title-undefined');
    const sizeTypeContentShort = that.querySelector('.option-content-short');
    const sizeTypeContentRegular = that.querySelector('.option-content-regular');
    const sizeTypeContentLong = that.querySelector('.option-content-long');
    const sizeTypeContentUndefined = that.querySelector('.option-content-undefined');
    const titles = that.querySelectorAll('.size-option-title');
    const contents = that.querySelectorAll('.size-option-content');
    if(!!sizeTypeTitleShort){
      sizeTypeTitleShort.addEventListener('click', event => {
        that.hideAll(titles, contents);
        sizeTypeTitleShort.classList.add('active');
        sizeTypeContentShort.classList.remove('hidden');
      });
    }
    if(!!sizeTypeTitleRegular){
      sizeTypeTitleRegular.addEventListener('click', event => {
        that.hideAll(titles, contents);
        sizeTypeTitleRegular.classList.add('active');
        sizeTypeContentRegular.classList.remove('hidden');
      });
    }
    if(!!sizeTypeTitleLong){
      sizeTypeTitleLong.addEventListener('click', event => {
        that.hideAll(titles, contents);
        sizeTypeTitleLong.classList.add('active');
        sizeTypeContentLong.classList.remove('hidden');
      });
    }
    if(!!sizeTypeTitleUndefined){
      sizeTypeTitleUndefined.addEventListener('click', event => {
        that.hideAll(titles, contents);
        sizeTypeTitleUndefined.classList.add('active');
        sizeTypeContentUndefined.classList.remove('hidden');
      });
    }
  }
}
customElements.define('product-option-tabs', ProductOptionTabs);